export function getMaterialList(search, isEmployee, filters, sorts, page = -1, items = 10, articleId) {
    return new Promise((resolve, reject) => {
        let { getMaterialListRequest, getMaterialListError, getMaterialListResult } = this.props

        this.doAction(
            this.WEB_REQUEST_URL + 'get_material_list',
            this.createBundle(
                'get_material_list',
                { search: search ? search : '', articleId: articleId ? articleId : '', filters, sorts, page, items },
                this.POST,
                getMaterialListRequest,
                (result) => {
                    getMaterialListResult(result)
                    resolve(result)
                },
                (error) => {
                    getMaterialListError(error)
                    reject(error)
                }
            )
        )
    })
}
